<template>
  <div class="intro-section__powered-by">
    <template v-if="url">
      <a :href="url"
         target="_blank">
        <template v-if="asLogo">
          <img src="@/assets/misc/powered.svg" width="100" alt="Powered by Pica"/>
        </template>
        <template v-else>
          Powered by <span>getpica.com</span>
        </template>
      </a>
    </template>
    <template v-else>
       <template v-if="asLogo">
          <img src="@/assets/misc/powered.svg" width="150"  alt="Powered by Pica"/>
        </template>
        <template v-else>
          Powered by <span>getpica.com</span>
        </template>
    </template>
  </div>
</template>
<script>
export default {
  name: "PoweredBy",
  props: {
    url: {
      type: String,
      required: false,
    },
    asLogo: {
      type: Boolean,
      default: false,
    },
  }
}
</script>


<style scoped>

</style>